import { Stack } from '@mui/material'

import { preview } from '@/components/form/preview'
import { Field } from './Field'

import type { ExecutionEventsFormValues } from '../../../typings'
import { useTexts } from '../useTexts'

interface Props {
  value: ExecutionEventsFormValues['dynamicLoads']
  onChange: (key: string, value: number) => void
  testId?: string
  fieldDisabled?: boolean
}

export function LoadFields(props: Props) {
  const { value, onChange, testId, fieldDisabled } = props
  const texts = useTexts()

  const entries = Object.entries(value)

  return (
    <Stack direction="column" spacing={2} data-testid={testId}>
      {entries.map(([label, load]) => {
        if (load.disabled) {
          return (
            <preview.Field label={label} testId={`${testId}-${label}`}>
              {texts.undeclared}
            </preview.Field>
          )
        }
        return (
          <Field
            key={label}
            label={label}
            value={load.value}
            onChange={onChange}
            testId={`${testId}-${label}`}
            disabled={fieldDisabled}
          />
        )
      })}
    </Stack>
  )
}
